// extracted by mini-css-extract-plugin
export default {"input":"frequen-module--input--3hgj5","corpusInput":"frequen-module--corpus-input--qbv_l"};